module.exports = __webpack_public_path__ + "media/images/design_one-59c15f52ba56012c3f151e91a4bdb6cd.jpg";